import { Component, OnInit, EventEmitter, Input, Output, forwardRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { Book } from '../../../models/Book';
import { ServizioStampa } from '../../../models/ServizioStampa';
import { Collana } from '../../../models/Collana';
import { Onix } from '../../../models/Onix';

import { BookService } from './../../../services/book.service';

import { AppComponent } from './../../../app.component';

import { environment } from './../../../../environments/environment';

import { AllValidationErrors, getFormValidationErrors } from '../../../helpers/get-form-validation-errors'

const _DESCRIZIONE: string = '1';
const _SOMMARIO: string = '2';
const _NOTE_AUTORE: string = '3';

@Component({
  selector: 'app-servizio-stampa',
  templateUrl: './servizio-stampa.component.html',
  styleUrls: ['./servizio-stampa.component.css'],
  providers: [BookService]
})
export class ServizioStampaComponent implements OnInit {
  descrizione: ServizioStampa = new ServizioStampa();
  sommario: ServizioStampa = new ServizioStampa();
  noteautore: ServizioStampa = new ServizioStampa();
  collana: Collana;
  publisher: string;
  ean13: string;
  coverpath: string;
  tipoProdotto: Onix;
  loading: boolean;
  allErrors = [];

  private _form: FormGroup;
  @ViewChild('f') set form(ff: FormGroup) {
    if (ff != null && this._form == null) {
      this._form = ff;
      ff.valueChanges.subscribe(o => {
        this.checkErrors(ff);
      })
    }
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public parent: AppComponent,
    private bookService: BookService) {
    this.publisher = environment.publisher;
  }

  _titolo(tipo: string): string {
    switch (tipo) {
      case _DESCRIZIONE:
        return 'Descrizione dell\'opera';
      case _SOMMARIO:
        return 'Sommario';
      case _NOTE_AUTORE:
        return 'Note sull\'autore';
      default:
        return ''
    }
  }

  _getServizioStampa(wa, tipo) {
    if (wa) {
      let wo = wa.find((o) => {
        return o.tipo == tipo;
      })
      if (wo) {
        return wo;
      }
    }
    return new ServizioStampa({
      titolo: this._titolo(tipo),
      tipo: tipo
    });
  }

  ngOnInit() {
    let ean13 = this.route.snapshot.paramMap.get('ean13');
    console.log(ean13);
    this.loading = true;
    setTimeout(() => {
      this.bookService.getBook(ean13).subscribe(result => {
        console.log(result);
        if (result.success && result.book) {
          let wmodel = this.bookService.fromMongo(result.book);
          this._init(wmodel);
        }
        this.loading = false;
      })
    }, 500)
  }

  _init(wmodel: Book) {
    this.ean13 = wmodel.ean13;
    this.descrizione = this._getServizioStampa(wmodel.servizioStampa, _DESCRIZIONE);
    this.sommario = this._getServizioStampa(wmodel.servizioStampa, _SOMMARIO);
    this.noteautore = this._getServizioStampa(wmodel.servizioStampa, _NOTE_AUTORE);
    this.collana = wmodel.collana;
    this.tipoProdotto = wmodel.tipoProdotto;
    this.coverpath = this.bookService.getBookCoverPath(wmodel.ean13);
    console.log('ean13', this.ean13);
    console.log('coverpath', this.coverpath);
    console.log('collana', this.collana);
    console.log('descrizione', this.descrizione);
    console.log('sommario', this.sommario);
    console.log('note autore', this.noteautore);
  }

  persist() {
    if (this._form.valid) {
      this.loading = true;
      this.parent.addToast('', 'salvataggio in corso...', ((wid) => {
        setTimeout(() => {
          let wmodel = {
            ean13: this.ean13,
            descrizione: this.descrizione,
            sommario: this.sommario,
            noteautore: this.noteautore
          }
          console.log(wmodel)
          this.bookService.updateServizioStampa(wmodel).subscribe((res) => {
            console.log(res)
            if (res.success && res.r) {
              let wmodel = this.bookService.fromMongo(res.r.value);
              this._init(wmodel);
              this.callSitoEndpoint(this.ean13);
            }
            this.parent.clearToast(wid);
            this.loading = false;
            this.parent.operSnackBar(res.success, res.success ? 'salvataggio completato' : res.err)
          })
        }, 1000);
      }))
    }
  }

  apriSchedaLibro(_ean13: string) {
    this.router.navigate(['/book/' + _ean13]);
  }

  gotoSito(_ean13: string) {
    window.open(environment.urlPortale + '/control/dettagliolibro?ean13=' + _ean13, "_blank");
  }

  go2search() {
    this.router.navigate(['/book/search']);
  }

  callSitoEndpoint(ean13: string) {
    setTimeout(() => {
      this.bookService.callSitoEndpointEvo(ean13)
        .subscribe(res => {
          this.parent.addPopupToast('', res.success ? 'sincronizzazione portale completata' : 'sincronizzazione portale fallita', 5000, res.success, null)
          console.log(res);
        },
        error => {
          console.log(error);
          this.parent.addPopupToast('', 'sincronizzazione portale fallita', 5000, false, null)
        })
    }, 1000);
  }

  isSectionWithError(s: string) {
    return this.allErrors ? this.allErrors.some(item => item.control_name.indexOf(s) != -1) : false;
  }

  checkErrors(ff: FormGroup) {
    this.allErrors = [];
    if (ff) {
      if (!ff.valid) {
        for (var key in ff.controls) {
          ff.controls[key].markAsTouched({ onlySelf: true });
        }
        let ee = getFormValidationErrors(ff.controls);
        ee.forEach(e => {
          let text;
          switch (e.error_name) {
            case 'required': text = `${e.control_name}: campo obbligatorio`; break;
            case 'pattern': text = `${e.control_name}: formato errato`; break;
            case 'email': text = `${e.control_name}: formato errato`; break;
            default: text = e.error_value.message;
          }
          this.allErrors.push({ control_name: e.control_name, message: text.toLowerCase().replace(/_/g, ' ') });
        })
      }
    }
  }

  getTitle(): string {
    return "servizio stampa";
  }
}



// WEBPACK FOOTER //
// ./src/app/components/book/servizio-stampa/servizio-stampa.component.ts